/* ═══════════════════════════════════════════════════════════════
   ProjectService — Project CRUD via EC2 API (cloud, in-memory cache)
   ═══════════════════════════════════════════════════════════════ */

import type { Project } from '../../shared/types';
import * as cache from './cloudCache';
import type { TableOpts } from './cloudCache';
import { log as logActivity } from './activityLogger';

const projectOpts: TableOpts = {
  jsonFields: ['masters', 'selections', 'formaTokens'],
};

export const ProjectService = {
  list: async (): Promise<Project[]> => cache.list<Project>('projects', projectOpts),

  save: async (project: Project): Promise<Project> => {
    const isNew = !project.id;
    const saved = await cache.save('projects', project, projectOpts);
    logActivity({
      action: isNew ? 'project.create' : 'project.update',
      entityType: 'project',
      entityId: saved.id,
      metadata: { name: saved.name, projectNumber: saved.projectNumber },
    });
    return saved;
  },

  delete: async (id: string): Promise<void> => {
    await cache.remove('projects', id);
    logActivity({ action: 'project.delete', entityType: 'project', entityId: id });
  },
};
